// In-memory fixtures backing the mocked BillingoService. These stores are
// MUTABLE on purpose: createAccount / createDocument push into them so the
// running UI reflects new accounts and documents immediately (no backend yet).
//
// Shapes intentionally mirror Billingo's own API:
//   - "account" ≈ Billingo Partner (we never build our own representation)
//   - "document" ≈ Billingo proforma/advance/invoice block

import { DOC_TYPES } from '../../Utils/billingoDocuments';

// Billingo accounts (partners). Companies carry a tax/VAT number + registration
// id; individuals do not. `block` mirrors how Billingo identifies a partner.
export const mockAccounts = [
  {
    id: 9001,
    type: 'company',
    name: 'Danube Events Kft.',
    tax_number: '12345678-2-41',
    registration_number: '01-09-123456',
    emails: ['finance@danube-events.hu'],
    address: {
      country_code: 'HU', post_code: '1051', city: 'Budapest', address: 'Andrássy út 12.',
    },
  },
  {
    id: 9002,
    type: 'company',
    name: 'Alpine Travel GmbH',
    tax_number: 'ATU12345678',
    registration_number: 'FN 123456a',
    emails: ['ap@alpine-travel.at'],
    address: {
      country_code: 'AT', post_code: '1010', city: 'Wien', address: 'Kärntner Straße 5',
    },
  },
  {
    id: 9003,
    type: 'individual',
    name: 'John Smith',
    tax_number: null,
    registration_number: null,
    emails: ['john.smith@example.com'],
    address: {
      country_code: 'GB', post_code: 'SW1A 1AA', city: 'London', address: '10 Downing Street',
    },
  },
];

// bookingId -> array of created documents. Empty until createDocument pushes
// into it; only used when REACT_APP_BILLINGO_MOCK=true.
export const mockDocumentsByBooking = {};

// Monotonic counters for human-readable mock numbers, per document type.
const numberCounters = {
  [DOC_TYPES.DIJBEKERO]: 0,
  [DOC_TYPES.ELOLEGSZAMLA]: 0,
  [DOC_TYPES.SZAMLA]: 0,
};

const NUMBER_PREFIX = {
  [DOC_TYPES.DIJBEKERO]: 'DB',
  [DOC_TYPES.ELOLEGSZAMLA]: 'EL',
  [DOC_TYPES.SZAMLA]: 'SZ',
};

let accountIdSeq = 9100;

export function nextDocumentNumber(type) {
  numberCounters[type] = (numberCounters[type] || 0) + 1;
  const prefix = NUMBER_PREFIX[type] || 'DOC';
  const seq = String(numberCounters[type]).padStart(4, '0');
  return `${prefix}-2026-${seq}`;
}

export function nextAccountId() {
  accountIdSeq += 1;
  return accountIdSeq;
}
